import isDate from './isDate';
export default function(sPNum) {
	/* Remove dashes from number for easier manipulation */
	sPNum = sPNum.replace(/-/g, '');

	var numbers = sPNum.match(/^(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)(\d)$/);
	var checkSum = 0;
	var d = new Date();
	if (!isDate(sPNum.substring(0, 4), sPNum.substring(4, 6), sPNum.substring(6, 8))) {
		return false;
	}
	if (numbers == null) {
		return false;
	}
	var n;
	for (var i = 3; i <= 12; i++) {
		n = parseInt(numbers[i]);
		if (i % 2 == 0) {
			checkSum += n;
		} else {
			checkSum += ((n * 2) % 9) + Math.floor(n / 9) * 9;
		}
	}
	if (checkSum % 10 == 0) {
		return true;
	}
	return false;
}
